import {ReactNode} from "react";

import styles from "./MarketingBanner.module.scss";

interface MarketingBannerProps {
  icon: ReactNode;
  text: ReactNode;
  button: ReactNode;
}

export const MarketingBanner = ({icon, text, button}: MarketingBannerProps) => {
  return (
    <div className={`${styles.container} d-flex align-items-center justify-content-center`}>
      <div className="flex-shrink-0">{icon}</div>
      <h3 className={`${styles.textContainer} marketingTextH3Bold pulse-color-gray-100 mb-0 flex-grow-1`}>{text}</h3>
      <div className={`${styles.buttonsContainer} flex-shrink-0`}>{button}</div>
    </div>
  );
};
